export const BENEFIT_PAGES = {
  LIFE_INSURANCE: 'life-insurance',
  GOHENRY: 'gohenry',
  EARLY_CARD: 'early-card',
  COMPLIMENTARY_WILL: 'complimentary-will',
  TAX_FILING: 'tax-filing',
}

export const LIFE_INSURANCE_COHORT = 'benefits_insurance_standard'

export const BENEFIT_PRODUCT_NAME = 'Benefits'
